export enum ProviderTerminationType {
  voluntary = 'voluntary',
  involuntary = 'involuntary',
  deceased = 'deceased',
}

export enum ProviderTerminationReason {
  provider_request = 'provider_request',
  retirement = 'retirement',
  personal_circumstances = 'personal_circumstances',
  pursuing_other_opportunities = 'pursuing_other_opportunities',
  quality = 'quality',
  communication = 'communication',
  policy_violation = 'policy_violation',
  recredentialing_deadline_missed = 'recredentialing_deadline_missed',
  credentialing_committee_denial = 'credentialing_committee_denial',
  licensing_issue = 'licensing_issue',
  conduct_boundary_violation = 'conduct_boundary_violation',
  unresponsive_provider = 'unresponsive_provider',
}

export const providerTerminationReasonByType: Record<ProviderTerminationType, ProviderTerminationReason[]> = {
  [ProviderTerminationType.voluntary]: [
    ProviderTerminationReason.provider_request,
    ProviderTerminationReason.retirement,
    ProviderTerminationReason.personal_circumstances,
    ProviderTerminationReason.pursuing_other_opportunities,
    ProviderTerminationReason.unresponsive_provider,
  ],
  [ProviderTerminationType.involuntary]: [
    ProviderTerminationReason.quality,
    ProviderTerminationReason.communication,
    ProviderTerminationReason.policy_violation,
    ProviderTerminationReason.recredentialing_deadline_missed,
    ProviderTerminationReason.credentialing_committee_denial,
    ProviderTerminationReason.licensing_issue,
    ProviderTerminationReason.conduct_boundary_violation,
  ],
  [ProviderTerminationType.deceased]: [],
};
